export var CompanyRoles;
(function (CompanyRoles) {
    CompanyRoles["ADMIN"] = "Admin";
    CompanyRoles["STANDARD"] = "Standard";
})(CompanyRoles || (CompanyRoles = {}));
export var CompanyIdentifierTypes;
(function (CompanyIdentifierTypes) {
    CompanyIdentifierTypes["VAT"] = "VAT";
    CompanyIdentifierTypes["ABN"] = "ABN";
    CompanyIdentifierTypes["NZBN"] = "NZBN";
})(CompanyIdentifierTypes || (CompanyIdentifierTypes = {}));
export var FiscalEntities;
(function (FiscalEntities) {
    FiscalEntities["TA"] = "TA";
    FiscalEntities["TPS"] = "TPS";
    FiscalEntities["TPA"] = "TPA";
    FiscalEntities["TPJ"] = "TPJ";
})(FiscalEntities || (FiscalEntities = {}));
export var UpdateRule;
(function (UpdateRule) {
    UpdateRule["SameBillingIdentifier"] = "sameBillingIdentifier";
})(UpdateRule || (UpdateRule = {}));
export var BillRunBatchPeriod;
(function (BillRunBatchPeriod) {
    BillRunBatchPeriod["EVERYDAY"] = "everyday";
    BillRunBatchPeriod["ON_ORDER"] = "onOrder";
    BillRunBatchPeriod["MONTHLY"] = "monthly";
    BillRunBatchPeriod["TWICE_MONTHLY"] = "twiceMonthly";
})(BillRunBatchPeriod || (BillRunBatchPeriod = {}));
//# sourceMappingURL=company.types.js.map